import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	columnAddButtonHint: {
		id: 'polaris-lib-board.add-column.column-add-button-hint.non-final',
		defaultMessage: 'Add option',
		description: 'Tooltip for button that adds a new board column',
	},
});
